// import { createSlice } from '@reduxjs/toolkit';
// import { User, UserProps } from '../types';
// import { decodeJWT, getLocalStorage } from '@/utils/common';
// import { CURRENT_USER_CODE, TOKEN_KEY } from '@/AppConfig';

// // const initialState: UserProps = {
// //   loggedUserData: getLocalStorage(TOKEN_KEY)
// //     ? (decodeJWT(getLocalStorage(TOKEN_KEY) as string) as User)
// //     : null,
// //   currentLoggedUserId: getLocalStorage(CURRENT_USER_CODE),
// // };

// const getInitialState = (): UserProps => {
//   const token = getLocalStorage(TOKEN_KEY);
//   return {
//     loggedUserData: token ? (decodeJWT(token as string) as User) : null,
//     currentLoggedUserId: getLocalStorage(CURRENT_USER_CODE),
//   };
// };

// const loginReducer = createSlice({
//   name: 'user',
//   //initialState: initialState,
//   initialState: getInitialState(),
//   reducers: {
//     loginSuccess(state, action) {
//       return {
//         ...state,
//         loggedUserData: action.payload.loggedUserData,
//         currentLoggedUserId: action.payload.loggedUserData.user_code,
//       };
//     },
//   },
// });

// export default loginReducer.reducer;
import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import { User, UserProps } from '../types';

const TOKEN_KEY = 'erps_token';
const CURRENT_USER_CODE = 'erps_user';

const getStoredValue = (key: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(key);
};

const getInitialState = (): UserProps => {
  const token = getStoredValue(TOKEN_KEY);
  const currentUserCode = getStoredValue(CURRENT_USER_CODE);

  if (!token) {
    return {
      loggedUserData: null,
      currentLoggedUserId: currentUserCode,
    };
  }

  try {
    const loggedUserData = jwtDecode(token) as User;

    return {
      loggedUserData,
      currentLoggedUserId: loggedUserData.user_code ?? currentUserCode,
    };
  } catch {
    return {
      loggedUserData: null,
      currentLoggedUserId: currentUserCode,
    };
  }
};

const loginReducer = createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers: {
    loginSuccess(state, action) {
      state.loggedUserData = action.payload.loggedUserData;
      state.currentLoggedUserId =
        action.payload.loggedUserData?.user_code ?? null;
    },
  },
});

export default loginReducer.reducer;
export const { loginSuccess } = loginReducer.actions;
